import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  BrowserRouter as Router,
  Route,
  NavLink as Link,
  withRouter,
} from 'react-router-dom';

import Admin from '../../pages/Admin';
import Home from '../../pages/Home';
import Agenda from '../../pages/Agenda';
import People from '../../pages/People';
import EnterCode from '../../molecules/EnterCode';
import Button from '../../atoms/Button';
import LoadingIndicator from '../../atoms/LoadingIndicator';

import {
  resolveParams
} from '../../../module/RoutingUtils';
import config from '../../../config/site';
import './Stag.css';

class Stag extends Component {

  constructor(...args) {
    super(...args);
    this.state = {
      selectedStag: null,
    };
  }

  componentWillMount() {
    if ( this.props.match.params.selectedStag ) {
      this.setSelectedStag(this.props.match.params.selectedStag);
      if ( !this.props.networkStatus && this.props.location.pathname.indexOf('/admin') > -1 ) {
        this.props.history.push(this.props.match.url);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if ( nextProps.adminVisible ) window.clearTimeout(this.specialCountTimeoutId);

    // change subscription if stag has changed
    if ( nextProps.match.params.selectedStag !== this.props.match.params.selectedStag ) {
      if ( this.props.match.params.selectedStag ) {
        this.props.deregisterStagListeners(this.listeners, this.props.match.params.selectedStag);
      }
      if ( nextProps.match.params.selectedStag ) {
        this.setSelectedStag(nextProps.match.params.selectedStag);
      }
    }

    // when we come back online, re-subscribe to this stag
    if ( nextProps.match.params.selectedStag ) {
      if ( nextProps.networkStatus && !this.props.networkStatus ) {
        this.setSelectedStag(nextProps.match.params.selectedStag);
      }
    }
  }

  componentWillUnmount() {
    if ( this.intervalId ) window.clearInterval(this.intervalId);
    if ( this.specialCountTimeoutId ) window.clearTimeout(this.specialCountTimeoutId);
    if ( this.listeners ) this.props.deregisterStagListeners(this.listeners, this.props.match.params.selectedStag);
    this.props.setSelectedStag();
  }

  setSelectedStag = (stag) => {
    const that = this;

    this.listeners = this.props.setSelectedStag(stag);
    if ( this.intervalId ) window.clearInterval(this.intervalId);
    // refresh potentially stale data every 60 seconds
    this.intervalId = window.setInterval(() => {
      that.props.fetchData(stag);
    }, 60*1000);

    this.props.getCodeForStag(stag);

  }

  render() {

    const {adminVisible, loading, siteTitle, hasStagData, exists, code, networkStatus, userHasJoinedStag} = this.props;
    const {selectedStag} = this.state;

    const updateSelectedStag = (code) => {
      this.setState({
        selectedStag: code
      });
    };

    const selectStag = () => {
      if ( selectedStag ) {
        this.props.getStagForCode(selectedStag).then(stag => {
          if ( stag ) {
            this.props.joinStag(stag).then(() => {
              this.props.history.push(resolveParams({
                path: this.props.match.path.replace(':selectedStag?', stag),
                params: this.props.match.params,
              }));
            });
          } else {
            this.props.history.push(resolveParams({
              path: this.props.match.path.replace(':selectedStag?', 'not-found'),
              params: this.props.match.params,
            }));
          }
        });
      }
    };

    if ( !this.props.match.params.selectedStag ) {
      return (
        <div className="Stag">
          <div className="enter-code">
            <label> Enter 5 Digit Code </label>
            <EnterCode
              codeLength={5}
              code={selectedStag}
              setCode={updateSelectedStag}
            />
            <div>
              <Button onClick={selectStag}> Go </Button>
            </div>
          </div>
        </div>
      );
    } else if ( !loading && !exists ) {
      return (
        <div className="Stag">
          {networkStatus ? (
            <p> Selected Stag does not exist. </p>
          ) : (
            <p> Could not load selected stag. </p>
          )}
          <Link to="/stag"> Go back to select another stag </Link>
        </div>
      );
    }

    if ( loading && !hasStagData ) {
      return (
        <div className="Stag">
          <LoadingIndicator />
        </div>
      );
    }

    // check that the user is an admin or is a member of the stag
    if ( !adminVisible && !userHasJoinedStag ) {
      return (
        <div>
          <p> You have not joined this stag. </p>
          <p> To join, go back and enter the code for the stag. </p>
          <Link to="/stag"> Back </Link>
        </div>
      )
    }

    return (
      <Router>

        <div className={"Stag" + (adminVisible ? " admin-mode" : "")}>

          <div className="Stag-header">

            <h2>{siteTitle}</h2>

            <div className="Stag-code">
              <span>Code</span>
              <span className="code">{code}</span>
            </div>

            <nav>
              <Link activeClassName="active" exact to={`${this.props.match.url.replace(/\/$/, "")}/`}>Home</Link>
              |
              <Link activeClassName="active" to={`${this.props.match.url.replace(/\/$/, "")}/agenda`}>Agenda</Link>
              |
              <Link activeClassName="active" to={`${this.props.match.url.replace(/\/$/, "")}/people`}>{config.peopleTitle}</Link>
              {adminVisible && (
                "|"
              )}
              {adminVisible && (
                <Link activeClassName="active" disabled={!networkStatus} to={`${this.props.match.url.replace(/\/$/, "")}/admin`}>Admin</Link>
              )}
            </nav>

          </div>

          <main>
            <Route exact path={`${this.props.match.path.replace(/\/$/, "")}/`} component={Home} />
            <Route path={`${this.props.match.path.replace(/\/$/, "")}/agenda/:date?`} component={Agenda} />
            <Route exact path={`${this.props.match.path.replace(/\/$/, "")}/people`} component={People} />
            {adminVisible && (
              <Route path={`${this.props.match.path.replace(/\/$/, "")}/admin`} component={Admin} />
            )}
          </main>

        </div>

      </Router>
    );
  }
}

Stag.defaultProps = {
  adminVisible: false,
  loading: false,
  siteTitle: "Stag",
  exists: false,
};

Stag.propTypes = {
  code: PropTypes.string.isRequired,
  adminVisible: PropTypes.bool.isRequired,
  hasStagData: PropTypes.bool.isRequired,
  fetchData: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  siteTitle: PropTypes.string.isRequired,
  exists: PropTypes.bool.isRequired,
  userHasJoinedStag: PropTypes.bool.isRequired,
  joinStag: PropTypes.func.isRequired,
};

export default withRouter(Stag);



// WEBPACK FOOTER //
// ./src/component/organisms/Stag/component.js